import Typography from '@hellodarwin/core/lib/components/common/typography';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const FileBoxContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  background-color: ${({ theme }) => theme.colors.beige_2};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const DownloadIconContainer = styled.div `
  position: static;
  padding: 8px;
  cursor: pointer;
  z-index: 2;

  ${media.xl `
    position: absolute;
    top: 0px;
    right: 0px;
  `}
`;
export const FileBoxContentContainer = styled.div `
  display: flex;
  flex: 1;
  flex-direction: row;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme }) => `${theme.spacing.sm + theme.spacing.xs}px ${theme.spacing.sm}px ${theme.spacing.sm + theme.spacing.xs}px ${theme.spacing.md}px`};

  ${media.xl `
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm - theme.spacing.xs / 2}px;
    align-items: center;
    padding: ${({ theme }) => `${theme.spacing.sm + theme.spacing.xs}px ${theme.spacing.sm}px`};
  `}
`;
export const FileBoxTitle = styled(Typography) `
  display: -webkit-box;
  overflow: hidden;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  ${media.xl `
    text-align: center;
  `}
`;
export const FileIconContainer = styled.div `
  width: fit-content;
  height: fit-content;
  padding: 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.grey_1};
  line-height: 0;
`;
export const FileBoxDetailsContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${media.xl `
    align-items: center;
  `}
`;
export const FileBoxDetail = styled(Typography) `
  ${media.xl `
    text-align: center;
    width: 50%;
  `}
`;
export const FileBoxContentHeader = styled.div `
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
